import React, {
  useEffect,
  useMemo,
  useState
} from "react"

import axios from "axios"

import Cookies from "js-cookie"
import { getFoodImageUrl } from "../utils/foodAvailability"

const API =
  "https://food-backend-9733.onrender.com"

const AdminRequirements = () => {

  const [requirements, setRequirements] =
    useState([])

  const [search, setSearch] =
    useState("")

  const [currentPage, setCurrentPage] =
    useState(1)

  const [itemsPerPage, setItemsPerPage] =
    useState(10)

  const token = JSON.parse(
    Cookies.get("logincrd") || "{}"
  )?.token

  const loadRequirements = () => {

    axios.get(
      `${API}/admin/product-requirements`,
      {
        headers: {
          Authorization:
            `Bearer ${token}`
        }
      }
    )

    .then(res => {
      setRequirements(res.data)
    })

    .catch(err =>
      console.log(err)
    )
  }

  useEffect(() => {

    loadRequirements()

  }, [])

  const filteredRequirements =
    useMemo(() => {

      const value =
        search.toLowerCase()

      return requirements.filter(item => (

        String(item.id)
          .includes(value) ||

        item.user_name
          ?.toLowerCase()
          .includes(value) ||

        item.food_name
          ?.toLowerCase()
          .includes(value) ||

        item.requirement
          ?.toLowerCase()
          .includes(value)

      ))

    }, [requirements, search])

  const totalPages = Math.ceil(
    filteredRequirements.length /
    itemsPerPage
  )

  const startIndex =
    (currentPage - 1) *
    itemsPerPage

  const paginatedRequirements =
    filteredRequirements.slice(
      startIndex,
      startIndex + itemsPerPage
    )

  return (

    <div className="admin-orders-page">

      <div className="admin-list-hero">
        <div>
          <span>
            Customer Requests
          </span>

          <h1>
            Custom Requirements
          </h1>

          <p>
            Review special quantity, taste and delivery notes from customers.
          </p>
        </div>

        <div className="admin-list-count">
          <b>{filteredRequirements.length}</b>
          <span>Requests</span>
        </div>
      </div>

      <div className="admin-filter-row">

        <input
          className="admin-order-search"

          type="text"

          placeholder="Search requirement..."

          value={search}

          onChange={(e) => {

            setSearch(e.target.value)

            setCurrentPage(1)
          }}
        />

        <div className="admin-pagination-top">

          <span>
            Show
          </span>

          <select

            value={itemsPerPage}

            onChange={(e) => {

              setItemsPerPage(
                Number(e.target.value)
              )

              setCurrentPage(1)
            }}
          >

            <option value={10}>
              10 Requests
            </option>

            <option value={25}>
              25 Requests
            </option>

            <option value={50}>
              50 Requests
            </option>

          </select>

          <span>
            per page
          </span>

        </div>

      </div>

      <div className="admin-table-wrapper">

        <table className="admin-orders-table">

          <thead>

            <tr>

              <th>
                ID
              </th>

              <th>
                Customer
              </th>

              <th>
                Product
              </th>

              <th>
                Type
              </th>

              <th>
                Requirement
              </th>

            </tr>

          </thead>

          <tbody>

            {
              paginatedRequirements.map(item => (

                <tr key={item.id}>

                  <td>
                    #{item.id}
                  </td>

                  <td>
                    <div className="admin-table-stack">
                      <b>
                        {item.user_name}
                      </b>

                      <small>
                        {item.user_email}
                      </small>
                    </div>
                  </td>

                  <td>

                    <div className="admin-product-cell">

                      <img
                        src={getFoodImageUrl(
                          {
                            image: item.food_image,
                            images: item.food_images
                          },
                          API
                        )}
                        alt={item.food_name}
                        onError={(e) => {
                          e.currentTarget.src = "/logo192.png"
                        }}
                      />

                      <span>
                        {item.food_name}
                      </span>

                    </div>

                  </td>

                  <td>

                    {
                      item.selected_size === "custom"
                        ? "Custom Requirement"
                        : item.selected_size
                    }

                  </td>

                  <td>
                    {item.requirement}
                  </td>

                </tr>
              ))
            }

          </tbody>

        </table>

      </div>

      <div className="admin-pagination">

        <button
          disabled={currentPage === 1}

          onClick={() =>

            setCurrentPage(
              currentPage - 1
            )
          }
        >
          Previous
        </button>

        <span>

          Page
          {" "}
          {currentPage}
          {" "}
          of
          {" "}
          {totalPages || 1}

        </span>

        <button

          disabled={
            currentPage === totalPages ||
            totalPages === 0
          }

          onClick={() =>

            setCurrentPage(
              currentPage + 1
            )
          }
        >
          Next
        </button>

      </div>

    </div>
  )
}

export default AdminRequirements
